import React, { FC } from 'react';

import cn from 'classnames';

import { useSlideOutContext } from '../context/SlideOutContext';

export const SlideOutMask: FC = () => {
  const { isOpen, onClose } = useSlideOutContext();

  const onCloseWithReason = () => {
    onClose?.('mask');
  };

  return (
    <div
      className={cn('fixed inset-0 z-20 bg-gray-700 bg-opacity-50 transition-opacity duration-150 ease-in-out', {
        'pointer-events-none opacity-0': !isOpen
      })}
      data-testid='slide-out-mask'
      onClick={onCloseWithReason}
    />
  );
};
